import {SEARCH_DELAY_IN_MS} from '@hconnect/common/consts'
import {useMainEquipmentFilterOptionsSearch} from '@hconnect/common/hooks'
import {EquipmentData} from '@hconnect/common/types'
import {getEquipmentLabel} from '@hconnect/common/utils'
import {useDebounce} from '@react-hook/debounce'
import {FilterSearchAutocomplete, FilterSearchAutocompleteProps} from '@widgets/common-filters'

export const TaskMainEquipmentSearchFilter = <TName extends string>(
  props: Omit<
    FilterSearchAutocompleteProps<TName, EquipmentData>,
    'options' | 'getOptionLabel' | 'getOptionValue' | 'isOptionEqualToValue' | 'searchTerm'
  > & {
    plantId: string
  }
) => {
  const [debouncedSearchText, setDebouncedSearchTerm] = useDebounce('', SEARCH_DELAY_IN_MS)

  const {data: suggestions, isFetching} = useMainEquipmentFilterOptionsSearch(
    props.plantId,
    debouncedSearchText
  )

  return (
    <FilterSearchAutocomplete<TName, EquipmentData>
      {...props}
      options={suggestions ?? []}
      getOptionLabel={getEquipmentLabel}
      getOptionValue={(option) => option.id}
      isOptionEqualToValue={(option, value) =>
        option.id === value.id && option.idType === value.idType
      }
      isLoading={isFetching}
      searchTerm={debouncedSearchText}
      onSearchChange={setDebouncedSearchTerm}
    />
  )
}
